import { AvatarParts } from "@scaleaq/sui-react";
import { PopoverTrigger } from "../trigger/Popover.trigger";
import { Button } from "src/components/button/Button";
import type { Merge } from "@scaleaq/sui-react/utility/types";
import styles from "./Popover.avatar.module.scss";

export namespace PopoverAvatar {
	export type ElementName = "Popover.Avatar";
	export type ElementType = HTMLSpanElement;
	export type Props = Merge<Omit<PopoverTrigger.Props, "render">, Button.Props> & {
		avatar?: AvatarParts.Root.Props;
		fallback?: string;
	};
}

export const PopoverAvatar = (componentProps: PopoverAvatar.Props) => {
	const { fallback, avatar, children, size = "medium", color = "neutral", variant = "bordered", ...restProps } = componentProps;

	return(
		<PopoverTrigger {...restProps} 
			render={
				<Button
					className={styles["avatar-trigger"]}
					size={size}
					color={color}
					variant={variant}
					leftIcon={
						<AvatarParts.Root {...avatar}>
							<AvatarParts.Fallback>{fallback}</AvatarParts.Fallback>
						</AvatarParts.Root>
					}
				>	
					{children}
				</Button>
			} 
		/>
	);
};
